import PayslipList from '@/controllers/payslip/payslip-list.js';
import axios from 'axios';

export default {
  extends: PayslipList,

  data() {
    return {
      approveForm: {
        payment_method_id: 0
      },
      submitted: false,
      paymentMethodArr: [],
    };
  },

  methods: {
    updateStatus(status) {
      if (!this.selectedPayslipIds.length) {
        alert('Please select at least one payslip.');
        return;
      }

      if (status === this.approveStatus) {
        this.submitted = false;
        this.approveForm.payment_method_id = 0;
        this.clearValidationErrors();
        this.$bvModal.show('approve-modal');
        return;
      }

      this.$options.extends.methods.updateStatus.call(this, status);
    },

    confirmApprove() {
      this.submitted = true;
      if (this.approveForm.payment_method_id == 0) {
        return;
      }

      const endpoint = this.getPayslipStatusEndpoint(this.approveStatus);
      const request = {
        emp_payment_ids: this.selectedPayslipIds,
        payment_method_id: this.approveForm.payment_method_id,
      };

      this.clearValidationErrors();
      this.isLoading = true;
      axios.post(endpoint, request)
        .then(response => {
          this.isLoading = false;
          this.$bvModal.hide('approve-modal');
          this.checkAll = false;
          this.selectedPayslipIds = [];

          const isSearch = this.searchData && this.searchData.is_search ? this.searchData.is_search : 0;
          this.getPayslips(isSearch, 1);

          if (response.data && response.data.success && this.$notification) {
            this.$notification.success('Payslip approved successfully', {
              timer: 3,
              position: 'bottomCenter'
            });
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else if (error.response && error.response.status === 422) {
            this.printValidationError(error.response);
          } else {
            this.$notification?.error?.('Error approving payslip', { timer: 3, position: 'bottomCenter' });
          }
          this.isLoading = false;
        })
        .finally(() => {
          this.$bvModal.hide('approve-modal');
        });
    },

    getPaymentMethod() {
      axios.get('paymentMethod/getPaymentMethodArray')
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Payment Method'
          }];
          this.paymentMethodArr = $defaultSelectOption.concat(res.data[0]);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },
  },

  mounted() {
    this.getPaymentMethod();
  },
}
